module.exports = __webpack_public_path__ + "img/syukyaku-sytem-001.dd5a55f1.jpg";